"use client";

import { ArrowUp } from "lucide-react";
import { UPLOADER_ID } from "./HeroSection";

export default function FinalCta() {
  const scrollToUploader = () =>
    document.getElementById(UPLOADER_ID)?.scrollIntoView({ behavior: "smooth", block: "start" });

  return (
    <section className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto rounded-3xl bg-gradient-to-r from-blue-600 to-purple-600 px-6 py-10 text-center text-white shadow-xl">
        <h2 className="text-2xl md:text-3xl font-bold mb-6">
          Your next application deserves a better resume
        </h2>
        <button
          type="button"
          onClick={scrollToUploader}
          className="inline-flex items-center gap-2 rounded-xl bg-white px-6 py-3 font-semibold text-blue-700 shadow-lg hover:bg-blue-50"
        >
          <ArrowUp className="h-4 w-4" />
          Tailor my resume for free
        </button>
      </div>
    </section>
  );
}
